import { createFileRoute } from '@tanstack/react-router';
import { OAuthResumePage } from '@/pages/oauth/OAuthResumePage';

export const Route = createFileRoute('/_oauth/oauth/resume')({
	component: OAuthResumePage,
});
